<!-- <p>asset-comparison works!</p> -->
<div class="main-comparison-div">
    <span style="font-size: larger; font-weight: bolder;">Compare Assets</span>
    <div class="middle-div alignRow">
        <button mat-raised-button style="margin-right: 1em;" color="primary" (click)="compare()"
            [disabled]="! this.comparingAssets || this.comparingAssets.length == 0">Compare</button>
        <div class="switch-div alignRow">
            <mat-slide-toggle color="primary" (change)="chartOnlyChange($event.checked)"
                [checked]="defaultValue"></mat-slide-toggle>
            <span>Charted Datapoints Only</span>
        </div>
        @if (comparingAssets.length > 0) {
        <div class="SI-container alignRow">
            @for (si of datapointSIs; track $index) {
            <div class="SI-div alignRow">
                <mat-checkbox id="{{si.SI}}" #siCheckbox color="primary"
                    (change)="toggleSICheckbox($event, si.SI)"></mat-checkbox>
                <span class="datapoint-title">{{si.SI}}</span>
            </div>
            }
        </div>
        }
        <span class="toolbar-spacer"></span>
        @if (selectedLocation) {
        <mat-icon style="cursor: pointer;" (click)="filterByLocation($event, true)">close</mat-icon>
        }
        <div class="location-dropdown">
            <ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='MainLocations'
                placeholder="Select Location" [fields]="locationFields" (change)="filterByLocation($event)"
                [allowFiltering]="true" filterType="contains">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.Name }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <div class="selection-container"
        [ngStyle]="{'grid-template-columns': '1fr '.repeat((this.comparingAssets.length + 1) <= 5 ? this.comparingAssets.length + 1 : 5)}">
        <div
            *ngFor="let i of [].constructor((comparingAssets.length + 1) <= 5 ? comparingAssets.length + 1 : 5) let idx = index">
            @let asset = comparingAssets[idx];

            <div class="selection-div">
                <mat-form-field>
                    <mat-label>Search for an Asset</mat-label>
                    <input matInput (keyup)="onFilteringAssets($event, idx)" placeholder="Search" #input>
                </mat-form-field>
                <div class="alignRow alignColumn" [ngClass]="asset ? 'dropdown-cancel':'dropdown'">
                    <ejs-dropdownlist id="{{idx}}" #assetDropdown [dataSource]='filteredAssetList'
                        placeholder="Select Asset" [fields]="assetFields" (change)="selectAsset($event, idx)">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.Name }} - {{ data.Description }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                    @if (asset) {
                    <span class="app-icon app-icon--close cancel-button"
                        (click)="clearSelection(idx)"><mat-icon /></span>
                    }
                </div>
            </div>
            @if (asset) {
            <div class="asset-details">
                <div class="alignRow alignColumn">
                    <img width="100%" height="100px" style="border-radius: var(--default-border-radius);"
                        (click)="viewImage(imagePathAssets() + asset.AssetID + '?' + asset.Modified)"
                        src="{{imagePathAssets()}}{{asset.AssetID}}?{{asset.Modified}}"
                        alt="{{comparingAssets[idx].Name}}"
                        onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
                </div>
                <div class="details-section">
                    <span>Name:</span>
                    <span><b>{{ asset.Name }}</b></span>
                    <span>Description:</span>
                    <span><b>{{ asset.Description }}</b></span>
                    @if (asset.ParentFunctionalLocation) {
                    <span>FL:</span>
                    <span><b>{{ asset.ParentFunctionalLocation }}</b></span>
                    }
                    @if (asset.EquipmentCode) {
                    <span>EQ:</span>
                    <span><b>{{ asset.EquipmentCode }}</b></span>
                    }
                </div>
                <div class="functional-location-button">
                    <button mat-raised-button color="primary" (click)="goToFunctionalLocation(asset)"
                        class="app-icon--goto">
                        <span>Go To Asset</span>
                        <mat-icon />
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
    @if (comparingAssets.length > 0) {
    <div class="chart-container">
        @if (assetDataPoints.length > 0) {
        <div class="chart-details"
            [ngStyle]="{'grid-template-columns': '1fr '.repeat((this.assetDataPoints.length + 1) <= 5 ? this.assetDataPoints.length + 1 : 5)}">
            @for (list of assetDataPoints; track $index) {
            <div class="datapoint-list">
                @for (datapoint of list; track $index) {
                <!-- <ng-container *ngFor="let datapoint of list"> -->
                @if (!(datapoint.IsCumulative && datapoint.ShowDeltaValue)) {
                <div class="datapoint-div alignRow">
                    <mat-checkbox id="{{datapoint.DataPointID}}" #datapointCheckbox color="primary"
                        (change)="toggleCheckbox($event, datapoint)"></mat-checkbox>
                    <span class="colour-box" [style.background-color]="getColor(datapoint)"></span>
                    <span class="datapoint-title" title="{{datapoint.DPTitle}}">{{ datapoint.DPTitle }}</span>
                </div>
                }
                <!-- </ng-container> -->
                }
            </div>
            }
        </div>
        }
        <div class="chart-div alignColumn alignRow">
            <div class="graph alignColumn alignRow">
                <ejs-chart style="width: 100%; height: 100%;" #myChart2 id="myChart2" [primaryXAxis]='sensorXAxis'
                    [zoomSettings]="zoomSettings" [legendSettings]='legend' [tooltip]='tooltipSettings'
                    [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings"
                    [selectionMode]=' selectionMode' [palettes]='palette' (legendClick)="legendClick($event)"
                    (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)"
                    (chartMouseDown)="checkClick($event)" (tooltipRender)="onTooltipRender($event)">
                </ejs-chart>
                <!-- (seriesRender)="checkAllSIEnabled()" -->
                <!-- Spinner -->
                @if (spinner) {
                <div class="local-spinner">
                    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                        [attr.x-contenttype]="'image/gif'" alt="Loading..." />
                </div>
                }
            </div>
            @if (visibleStartDate && visibleEndDate) {
            <span matTooltip="{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}"
                class="hideoverflow">{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}
            </span>
            }
            <div class="noshrink alignRow">
                <mat-icon matTooltip="Navigate Backwards" (click)="navigateByDuration(false)">chevron_left</mat-icon>

                <app-duration-selector [(duration)]="strDuration"
                    (durationChange)="selectTime($event)"></app-duration-selector>

                <mat-icon matTooltip="Navigate Forwards" (click)="navigateByDuration(true)">chevron_right</mat-icon>

                <span mat-icon-button [matMenuTriggerFor]="timeMenu" #timeTrigger="matMenuTrigger"
                    style="margin-left: 10px;" class="alignRow" matTooltip="Date Range">
                    <mat-icon>access_time</mat-icon>
                </span>
                <span class="me-auto"></span>

                <mat-menu #timeMenu="matMenu">
                    <div style="margin: 1em;">
                        <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                            [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                    </div>
                </mat-menu>
            </div>
            @if (includesCumulativeDatapoints) {
            <button mat-icon-button class="graph-button" (click)="toggleShowBars($event)">
                <mat-icon>{{showBars ? "show_chart" : "bar_chart"}}</mat-icon>
            </button>
            }
        </div>
    </div>
    }
    @if (statistics.length > 0) {
    <div class="statistics-div">
        <!-- <span style="font-size: larger; font-weight: bolder;">Statistics</span> -->
        <div class="statistics-item" style="border-top: 0px !important;">
            <span>Datapoint</span>
            <span>Max</span>
            <span>Min</span>
            <span>Average</span>
            <span>Sample Count</span>
        </div>
        <div class="statistics-list">
            @for (data of filteredStatistics; track $index) {
            <div class="statistics-item">
                <span>{{data.datapoint.DPTitle}}</span>
                <span>{{data.max}}{{data.datapoint.SI}}</span>
                <span>{{data.min}}{{data.datapoint.SI}}</span>
                <span>{{data.average}}{{data.datapoint.SI}}</span>
                <span>{{data.sampleCount}}</span>
            </div>
            }
        </div>
    </div>
    }
    @if (cumulativeStatistics.length > 0 && includesCumulativeDatapoints) {
    <div class="statistics-div">
        <!-- <span style="font-size: larger; font-weight: bolder;">Statistics</span> -->
        <div class="statistics-item" style="border-top: 0px !important;">
            <span>Datapoint</span>
            <span>Start</span>
            <span>End</span>
            <span>Usage</span>
            <span>Sample Count</span>
        </div>
        <div class="statistics-list">
            @for (data of cumulativeStatistics; track $index) {
            <div class="statistics-item">
                <span>{{data.datapoint.DPTitle}}</span>
                <span>{{data.min}}{{data.datapoint.SI}}</span>
                <span>{{data.max}}{{data.datapoint.SI}}</span>
                <span>{{data.difference}}{{data.datapoint.SI}}</span>
                <span>{{data.sampleCount}}</span>
            </div>
            }
        </div>
    </div>
    }
</div>